/**
 * Utilitário para combinar classes Tailwind de forma condicional.
 * Uso: cn("base-class", condition && "conditional-class", className)
 */
export function cn(...inputs: (string | undefined | null | false)[]): string {
  return inputs.filter(Boolean).join(" ");
}
